$shm_hitalama_agent_map_chat $shm_hitalama_agent_session
	server_url? \
	map_id \
	resize_side \left
	width? 432
	thinking_width 432
	panel_width_px \432px
	new_session_model null
	Side_resizer $shm_hitalama_resizer_side
		resize_side <= resize_side
		width? <=> width?
		width_px => width_px
	Map_sessions $shm_hitalama_agent_map_sessions
		server_url <= server_url
		map_id <= map_id
		session_id? <=> session_id? \
		new_session_model <= new_session_model
		opencode_session_ids? <=> scope_session_ids? /string
	style *
		^
		width <= panel_width_px
		flexBasis <= panel_width_px
		position \relative
	auto /
		^
		<= events_native null
	No_map_page $mol_page
		title \AI-агент
		body /
			<= No_map $mol_paragraph
				title <= no_map_text \Откройте карту
